import { observer } from 'mobx-react-lite'
import { FlipperFlagProps } from 'components/FlipperFlag/Types'
import { useRootStore } from 'stores/RootStore'
import { PropsWithChildren } from 'react'

const ensureArray = <T,>(input: T | T[] | undefined): T[] => {
  if (input === undefined) return []
  return Array.isArray(input) ? input : [input]
}

export const FlipperFlag = observer(({ enabled, disabled, children }: PropsWithChildren<FlipperFlagProps>) => {
  const { featureFlags } = useRootStore()
  const enabledArray = ensureArray(enabled)
  const disabledArray = ensureArray(disabled)

  const isEnabled =
    enabledArray.every((flag) => featureFlags.isActive(flag)) &&
    disabledArray.every((flag) => !featureFlags.isActive(flag))

  if (!isEnabled) {
    return null
  }

  return <>{children}</>
})
